import { queryOptions } from "@tanstack/react-query";
import { getCurrentUser } from "$/modules/appwrite/lib/appwrite";

export const currentUserQueryOptions = () =>
	queryOptions({
		queryKey: ["user"],
		queryFn: getCurrentUser,
		retry: false,
	});
